const getVisible = <T extends HTMLElement>(els: NodeListOf<T> | T[]): T | null => {
    return Array.from(els).find((el) => el.offsetParent !== null) ?? null;
};

const getDocumentOrShadowRoot = (hostSelector: string): Document | ShadowRoot | null => {
    if (typeof document === 'undefined') return null;

    const hostElement = document.querySelector<HTMLElement>(hostSelector);
    return hostElement?.shadowRoot ?? document;
};

export { getVisible, getDocumentOrShadowRoot };
